
import { createStore } from 'vuex'
import api from '../services/api'

export const UserStatus = {
  APPLYING: { value: 1, label: '申请' },
  APPROVED: { value: 2, label: '通过' },
  REJECTED: { value: 3, label: '拒绝' },
  REMOVED: { value: 4, label: '删除' }
}

export const UserRole = {
  ADMIN: { value: 'ADMIN', code: 20, label: '总经理' },
  MANAGER: { value: 'MANAGER', code: 12, label: '经理' },
  SUPERVISOR: { value: 'SUPERVISOR', code: 11, label: '主管' },
  USER: { value: 'USER', code: 1, label: '业务员' },
  ACCOUNTANT: { value: 'ACCOUNTANT', code: 2, label: '财务' },

  OTHER: { value: 'OTHER', code: 3, label: '后台人员' }
}

export const ProjectStatus = {
  New: { value: 'New', label: '订单新建', code: '1' },
  Initial: { value: 'Initial', label: '订单初始', code: '3' },
  Approvaled: { value: 'Approvaled', label: '订单批准', code: '2' },
  Check: { value: 'Check', label: '核账', code: '7' },
  Confirm: { value: 'Confirm', label: '确认订单', code: '4' },
  Payment: { value: 'Payment', label: '收款', code: '5' },
  Audit: { value: 'Audit', label: '验款', code: '6' },
  Completed: { value: 'Completed', label: '完成', code: '8' },
  Closed: { value: 'Closed', label: '关闭', code: '9' },
  PreAudit: { value: 'PreAudit', label: '预付款验款', code: '11' },
  PreCheck: { value: 'PreCheck', label: '预付款核账', code: '12' }
}

export const MessagePriority = {
  NORMAL: { value: 'NORMAL', label: '普通消息', code: '1' },
  HIGH: { value: 'HIGH', label: '通知消息', code: '2' },
  URGENT: { value: 'URGENT', label: '重要消息', code: '3' },
  CRITICAL: { value: 'CRITICAL', label: '紧急消息', code: '4' }
}


export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    role: localStorage.getItem('role') || null,
    customers: [],
    projects: [],
    allProjects: [],
    users: [],
    departments: [],
    teams: [],
    // 分页相关状态
    projectPagination: {
      currentPage: 1,
      pageSize: 10,
      total: 0
    },
    messagePagination: {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      messages: []
    },
    unreadCount: 0,
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    clearToken(state) {
      state.token = null
      localStorage.removeItem('token')
    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
      localStorage.setItem('refreshToken', refreshToken)
    },
    clearRefreshToken(state) {
      state.refreshToken = null
      localStorage.removeItem('refreshToken')
    },
    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    setRole(state, role) {
      state.role = role
      localStorage.setItem('role', role)
    },
    clearRole(state) {
      state.role = null
      localStorage.removeItem('role')
    },
    clearUser(state) {
      state.user = null
      localStorage.removeItem('user')
    },
    setUsers(state, users) {
      state.users = users
    },

    setDepartments(state, departments) {
      state.departments = departments
    },
    setTeams(state, teams) {
      state.teams = teams
    },
    setCustomers(state, customers) {
      state.customers = customers
    },
    setProjects(state, projects) {
      state.projects = projects
    },
    setAllProjects(state, projects) {
      state.allProjects = projects
    },
    setUnreadCount(state, count) {
      state.unreadCount = count
    },
    // 更新分页状态
    setProjectPagination(state, pagination) {
      state.projectPagination = { ...state.projectPagination, ...pagination }
    },
    setMessagePagination(state, pagination) {
      state.messagePagination = { ...state.messagePagination, ...pagination }
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await api.auth.login(credentials);
        if (response.status != 200 && response.code == 1402) {
          alert(`登录失败: ${response.message}`);
        }
        commit('setToken', response.data.accessToken);
        commit('setRefreshToken', response.data.refreshToken);
        commit('setUser', response.data.user);
        commit('setRole', response.data.user.role);
        return response;
      } catch (error) {
        throw error;
      }
    },

    async refreshToken({ commit, state }) {
      try {
        const response = await api.auth.refresh({ refreshToken: state.refreshToken });
        if (response.status === 200) {
          commit('setToken', response.data.accessToken);
          commit('setRefreshToken', response.data.refreshToken);
          commit('setUser', response.data.user);
          commit('setRole', response.data.user.role);
          return true;
        }
        return false;
      } catch (error) {
        console.error('Token refresh failed:', error);
        commit('clearToken');
        commit('clearRefreshToken');
        commit('clearUser');
        commit('clearRole');
        window.location.href = '/login';
        return false;
      }
    },
    async register({ commit }, userData) {
      try {
        const response = await api.auth.register(userData);
        if (response.status < 200 || response.status >= 300) {
          alert(`请求失败: ${response.message}`);
          return;
        }
        // commit('setToken', response.data.token);
        // commit('setUser', { username: response.data.username, role: response.data.role });
        // return response;
      } catch (error) {
        throw error;
      }
    },
    logout({ commit }) {
      commit('clearToken')
      commit('clearRefreshToken')
      commit('clearUser')
      commit('clearRole')
    },
    async fetchUsers({ commit }) {
      const response = await api.user.getAllUsers();
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const users = response.data;
      // console.log("fetchUsers response users:", users);
      commit('setUsers', users);
    },
    async getUsersByStatus({ dispatch }, { status }) {
      const response = await api.user.getUsersByStatus(status);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const users = response.data;
      // return users;
    },

    async updateUser({ dispatch }, userData) {
      const response = await api.user.updateUser(userData);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchUsers');
      // return response;
    },

    async assignUserPlacement({ dispatch }, userAssignmentDto) {
      const response = await api.user.assignUserPlacement(userAssignmentDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchUsers');
      // return response;    
    },

    async fetchDepartments({ commit }) {
      const response = await api.user.getDepartments();
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const departments = response.data;
      commit('setDepartments', departments);
    },

    async setDepartment({ dispatch }, organizationDto) {
      const response = await api.user.setDepartment(organizationDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchDepartments');
      // return response;    
    },

    async deleteDepartment({ dispatch }, id) {
      const response = await api.user.deleteDepartment(id);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchDepartments');
      // return response;
    },

    async fetchTeams({ commit }) {
      const response = await api.user.getTeams();
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const teams = response.data;
      commit('setTeams', teams);
    },


    async setTeam({ dispatch }, organizationDto) {
      const response = await api.user.setTeam(organizationDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchTeams');
      // return response;    
    },

    async deleteTeam({ dispatch }, id) {
      const response = await api.user.deleteTeam(id);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchTeams');
      // return response;    
    },

    async updatePassword({ dispatch }, data) {
      const response = await api.user.changePassword(data);
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.message || '密码修改失败');
      }
      // return response;
    },

    async fetchCustomers({ commit }) {
      const response = await api.customers.getAll();
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const customers = response.data;
      commit('setCustomers', customers);
    },

    // 获取未读消息数量
    async getUnreadCountMessage({ commit }) {
      try {
        const response = await api.messages.getUnreadCount();
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.message || '获取未读消息数失败');
        }
        commit('setUnreadCount', response.data);
        return response.data;
      } catch (error) {
        console.error('获取未读消息数失败:', error);
        return 0;
      }
    },

    async createCustomer({ dispatch }, customerData) {
      const response = await api.customers.create(customerData);
      if (response.status < 200 || response.status >= 300) {
        if (response.code !== 5001) {
          alert(`请求失败: ${response.message}`);
        }
        return response;
      }
      dispatch('fetchCustomers');
      return response;

    },

    async updateCustomer({ dispatch }, customerData) {
      const response = await api.customers.update(customerData.id, customerData);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      dispatch('fetchCustomers');
      // return response;
    },
    async deleteCustomer({ dispatch }, id) {
      const response = await api.customers.delete(id);
      // if (response.status < 200 || response.status >= 300) {
      //   alert(`请求失败: ${response.message}`);
      //   return;
      // }
      // dispatch('fetchCustomers');
      return response;
    },

    async importCustomers({ dispatch }, file) {
      const response = await api.customers.import(file);
      if (response.status < 200 || response.status >= 300) {
        // alert(`导入失败: ${response.message}`);
        return response;
      }
      dispatch('fetchCustomers');
      return response;
    },
    async createProject({ dispatch }, projectData) {
      const response = await api.projects.create({ ...projectData /*,customerId: projectData.customer.id*/ });
      if (response.status < 200 || response.status >= 300) {
        if (response.code !== 5001) {
          alert('新增失败:' + (response.message || response.data?.message))
        }
      }
      dispatch('fetchProjects');
      return response;
    },

    async updateProject({ dispatch }, projectData) {
      const response = await api.projects.update(projectData.id, projectData);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      // dispatch('fetchProjects');
      // return response;
    },

    async deleteProject({ dispatch }, id) {
      const response = await api.projects.delete(id);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      // dispatch('fetchProjects');
      // return response;
    },
    async fetchProjects({ commit }, payload = {}) {
      const { pagination = {}, includedComplete = false, isWarning = false } = payload
      // console.log("includedComplete:", includedComplete)
      const response = await api.projects.getPaginProjects(pagination, includedComplete, isWarning);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const projects = response.data.content || response.data;
      // 更新分页信息
      commit('setProjectPagination', {
        currentPage: response.data.pageable.pageNumber + 1 || 1,
        pageSize: response.data.pageable.pageSize || 10,
        total: response.data.totalElements || 0
      });
      commit('setProjects', projects);
      return {
        total: response.data.totalElements || 0, projects,
        currentPage: response.data.pageable.pageNumber + 1 || 1,
        data: projects
      };
    },
    async getPaginProjectsByQuery({ commit }, payload = {}) {
      const { pagination = {}, query = {} } = payload
      // console.log("payload.query:", payload.query)

      const response = await api.projects.getPaginProjectsByQuery(pagination, query);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const projects = response.data.content;
      commit('setProjects', projects);
      commit('setProjectPagination', {
        currentPage: response.data.pageable.pageNumber + 1 || 1,
        pageSize: response.data.pageable.pageSize || 10,
        total: response.data.totalElements || 0
      });
      return {
        total: response.data.totalElements || 0, projects,
        currentPage: response.data.pageable.pageNumber + 1 || 1,
        data: projects
      };
    },
    async getAllProjects({ commit }) {
      const response = await api.projects.getAll();
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      commit('setAllProjects', response.data || []);
      return response; // 返回文件数据
    },
    async exportExcel({ dispatch }, exportData) {
      const response = await api.projects.exportExcel(exportData);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      return response; // 返回文件数据
    },
    async getCustomerLatestProject({ dispatch }, customerId) {
      const response = await api.projects.getCustomerLatestProject(customerId);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      return response.data;
    },
    async getCustomerFirstProject({ dispatch },) {
      const response = await api.projects.getCustomerFirstProject();
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      return response;
    },
    async approved({ commit }, id) {
      const response = await api.projects.approved(id);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
    },
    async accepted({ commit }, acceptDto) {
      const response = await api.projects.accepted(acceptDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      // return response;
      // commit('setProjects', projects);
    },
    async rejected({ commit }, rejectDto) {
      const response = await api.projects.rejected(rejectDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
    },
    async checked({ commit }, checkDto) {
      const response = await api.projects.checked(checkDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      // return response;
      // commit('setProjects', projects);
    },
    async paid({ commit }, paidDto) {
      const response = await api.projects.paid(paidDto);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      // return response;
      // commit('setProjects', projects);
    },
    async audited({ commit }, paymentId) {
      const response = await api.projects.audited(paymentId);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      // return response;
      // commit('setProjects', projects);
    },
    async getProjectPayment({ commit }, projectId) {
      const response = await api.projects.getProjectPayments(projectId);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      return response.data;
    },

    async getMessages({ commit }, payload = {}) {
      const { pagination = {}, isRead = false } = payload
      const response = await api.messages.getMessages(pagination, isRead);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      const messages = response.data.content || response.data;
      commit('setMessagePagination', {
        currentPage: response.data.pageable.pageNumber + 1 || 1,
        pageSize: response.data.pageable.pageSize || 10,
        total: response.data.totalElements || 0,
        messages: messages
      })
      return messages;
    },
    async markAsRead({ commit }, messageId) {
      const response = await api.messages.markAsRead(messageId);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      return response.data;
    },
    async batchMarkAsRead({ commit }, messageIds) {
      const response = await api.messages.batchMarkAsRead(messageIds);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      commit('setUnreadCount', 0);
      return response.data;
    },
    async deleteMessage({ commit }, messageId) {
      const response = await api.messages.delete(messageId);
      if (response.status < 200 || response.status >= 300) {
        alert(`请求失败: ${response.message}`);
        return;
      }
      return response.data;
    },

    async subscribeToMessages({ commit }, userId) {
      try {
        const eventSource = await api.messages.subscribe(userId);
        console.log('SSE connection established in store');
        return eventSource;
      } catch (error) {
        console.error('SSE connection failed:', error);
        alert(`订阅消息失败: ${error.message || '未知错误'}`);
        throw error;
      }
    },

  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    allCustomers: state => state.customers,
    allProjects: state => state.allProjects,
    projectsWithWarnings: state => state.allProjects.filter(p => p.status !== ProjectStatus.Completed.value && p.status !== ProjectStatus.Closed.value && p.paymentWarning),
    // 分页信息getter
    projectPagination: state => state.projectPagination,
    messagePagination: state => state.messagePagination,
    unreadCount: state => state.unreadCount
  }
})
